import { render } from "./dynamicDetail.vue?vue&type=template&id=70d4f236"
import script from "./dynamicDetail.vue?vue&type=script&lang=js"
export * from "./dynamicDetail.vue?vue&type=script&lang=js"

import "./dynamicDetail.vue?vue&type=style&index=0&id=70d4f236&lang=scss"
import "./dynamicDetail.vue?vue&type=style&index=1&id=70d4f236&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__